// src/components/onboarding/steps/Step1Welcome.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import { useBranding } from '@/contexts/BrandingContext';
import { OnboardingStepProps } from '@/types/onboarding';
import MemoizedLogo from '@/components/branding/MemoizedLogo';
// Removed: import { Bot } from 'lucide-react';

const Step1Welcome: React.FC<Omit<OnboardingStepProps, 'goToPrevStep' | 'data' | 'updateData' | 'setStep'>> = ({ goToNextStep }) => {
  const { branding, isWhiteLabel } = useBranding();
  return (
    <div className="text-center">
        {/* Use partner logo if available, otherwise default */}
        <div className="flex justify-center p-0">
          <MemoizedLogo
            logoUrl={branding.logoUrl}
            companyName={branding.companyName}
            isWhiteLabel={isWhiteLabel}
            className="h-20 w-auto max-w-full object-contain"
          />
        </div>
      <h1 className="text-3xl font-bold mb-3 text-gray-800 dark:text-gray-100">
        {branding.customCopy.welcomeTitle || "Welcome! Let's set up your AI Employee."}
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
        {branding.customCopy.welcomeSubtitle || "We'll get your AI ready to handle calls in about 5 minutes. We just need a few key details to start."}
      </p>
      <Button onClick={goToNextStep} size="lg">
        {branding.customCopy.getStartedText || "Get Started"}
      </Button>
    </div>
  );
};

export default Step1Welcome;